import { gql } from "@urql/core";

export const pairsQuery = `
  query($query: String!) {
    pairs( query: $query) {
       network {
        id
        name
      }
      buyTax
      sellTax
      address
      pairFactory {
        name
        logoURL
      }
      token {
        logoUrl
        name
        symbol
        address
        decimals
        supply
        buyTax
        sellTax
        socialsAt
        telegram
        twitter
        description
        website
        discord
        scamAt
      }
      baseToken {
        logoUrl
        name
        symbol
        address
        decimals
      }
      volume24h
      liquidity
      priceNative
      priceUSD
      priceUSD24h
      isNative
    }
  }
`;

export const loginQuery = `
  mutation($username: String!, $password: String!) {
    login( input: {
        email: $username
        password: $password
      }
    ) {
      jwt
      refreshToken
      expired_at
      ip
      deviceType
      deviceModel
      deviceOs
      deviceClient
      user {
        id
        username
        firstName
        lastName
        photoURL
        role
      }
    }
  }
`;

export const telegramLoginMutation = `
  mutation TelegramLogin($input: TelegramLoginInput!) {
    telegramLogin(input: $input) {
      jwt
      refreshToken
      expired_at
      ip
      deviceType
      deviceModel
      deviceOs
      deviceClient
      user {
        id
        username
        firstName
        lastName
        photoURL
        role
      }
    }
  }
`;

export const updatePasswordQuery = `
  mutation($newPass: String!, $currPass: String!) {
    updatePassword(
        newPass: $newPass
        currPass: $currPass
    ) {
        username
        _id
    }
  }
`;

export const userInfoQuery = `
  query {
    currentUser {
      id
      username
      firstName
      lastName
      photoURL
      role
    }
    sessions {
      jwt
      refreshToken
      expired_at
      ip
      deviceType
      deviceModel
      deviceOs
      deviceClient
    }
  }
`;

export const sessionsQuery = `
query Sessions {
  sessions {
    jwt
    refreshToken
    expired_at
    ip
    deviceType
    deviceModel
    deviceOs
    deviceClient
  }
}
`;

export const updateUserMutation = `
    mutation($updateUserInput: UpdateUserInput!) {
        updateUser(updateUserInput: $updateUserInput) {
            username
             _id
         }
    }
`;

export const subcriptionTest = `
subscription {
  pair(pair: "0x88e6a0c2ddd26feeb64f039a2c41296fcb3f5640"){
    pair
    price
  }
}
`;

export const logOutMutation = `
  mutation {
    logout(
        refreshToken: "all"
    )
  }
`;

export const refreshMutation = `
  mutation($input: RefreshInput!) {
    refresh(input: $input) {
      jwt
      user {
        id
        username
        firstName
        lastName
        photoURL
        role
      }
    }
  }
`;

export const tokenEventsSubscription = `
subscription TokenEvents($filter: TokenFilter) {
  tokenEvents(filter: $filter){
    token {
      logoUrl
      createdAt
      address
      name
      symbol
      decimals
      supply
      deployer
      deployerBalance
      deploymentChecksum
      interfaceChecksum
      creationTx
      telegram
      twitter
      buyTax
      sellTax
      verifiedAt
      confirmedAt
      liquidityAt
      seenAt
      socialsAt
      socialsBy
      scamAt
      contractState
      description
      website
      email
      blog
      reddit
      slack
      github
      wechat
      linkedin
      discord
      whitepaper
      bitcointalk
      network {
        id
        explorer
        symbol
      }
    }
    event
  }
}
`;

export const tokensQuery = `
query Tokens($page: PageArgs!, $filter: TokenFilter) {
  tokens(page: $page, filter: $filter) {
    edges {
      cursor
      node {
        logoUrl
        createdAt
        address
        name
        symbol
        decimals
        supply
        deployer
        deployerBalance
        deploymentChecksum
        interfaceChecksum
        creationTx
        buyTax
        sellTax
        verifiedAt
        confirmedAt
        liquidityAt
        seenAt
        socialsBy
        scamAt
        telegram
        twitter
        contractState
        socialsAt
        description
        website
        email
        blog
        reddit
        slack
        github
        wechat
        linkedin
        discord
        whitepaper
        bitcointalk
        network {
          id
          explorer
          symbol
        }
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      totalCount
      startCursor
      endCursor
    }
  }
}`;

export const tokenQuery = `
query Token($address: String!) {
  token(address: $address) {
    logoUrl
    methods {
      key
      sigs {
        bytes
        signature
        returnArgs
      }
    }
    code {
      filename
      content
    }
  }
}
`;

export const tokenApprovalsQuery = `
query TokenApprovals($page: PageArgs!, $filter: TokenApprovalFilter) {
  tokenApprovals(page: $page, filter: $filter) {
    edges {
      cursor
      node {
        createdAt
        amount
        percent
        owner
        spender
        ownerBalance
        txHash
        network {
          explorer
        }
        token {
          logoUrl
          createdAt
          address
          name
          symbol
          decimals
          supply
          deployer
          deployerBalance
          deploymentChecksum
          interfaceChecksum
          creationTx
          buyTax
          sellTax
          telegram
          twitter
          verifiedAt
          confirmedAt
          seenAt
          socialsAt
          socialsBy
          scamAt
          contractState
          description
          website
          email
          blog
          reddit
          slack
          github
          wechat
          linkedin
          discord
          whitepaper
          bitcointalk
          network {
            id
            explorer
            symbol
          }
        }
        amount
        percent
        ownerBalance
        owner
        spender
        txHash
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      totalCount
      startCursor
      endCursor
    }
  }
}
`;

export const createNameTagMutation = `
mutation CreateNameTag($input: CreateNameTagInput) {
  createNameTag(input: $input) {
    name
    address
    network {
      symbol
      explorer
    }
    editable
    type
  }
}
`;

export const nameTagsQuery = `
query NameTags($pageArgs: PageArgs, $filter: NameTagFilter) {
  nameTags(pageArgs: $pageArgs, filter: $filter) {
    count
    edges {
      cursor
      node {
        id
        name
        address
        network {
          id
          explorer
        }
        editable
        type
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
`;

export const deleteNameTagMutation = `
  mutation DeleteNameTag($id: Int!) {
    deleteNameTag(id: $id)
  }
`;

export const updateNameTagMutation = `
mutation UpdateNameTag($input: UpdateNameTagInput) {
  updateNameTag(input: $input) {
    name
    address
    network {
      id
      symbol
      explorer
    }
    editable
    type
  }
}
`;

export const tokenApprovalSubscription = `
subscription TokenApprovals($filter: TokenApprovalFilter) {
  tokenApprovals(filter: $filter) {
    createdAt
    amount
    percent
    owner
    spender
    ownerBalance
    txHash
    network {
      id
      explorer
    }
    token {
      logoUrl
      createdAt
      address
      name
      symbol
      decimals
      supply
      deployer
      deployerBalance
      deploymentChecksum
      interfaceChecksum
      buyTax
      sellTax
      creationTx
      verifiedAt
      confirmedAt
      seenAt
      socialsBy
      scamAt
      telegram
      twitter
      contractState
      socialsAt
      description
      website
      email
      blog
      reddit
      slack
      github
      wechat
      linkedin
      discord
      whitepaper
      bitcointalk
      network {
        id
        explorer
        symbol
      }
    }
  }
}
`;

export const dexesQuery = `
query Dexes {
  dexes(networkId: 1) {
  	id
    name
    address
    network {
      id
      explorer
    }
    type
  }
}
`;

export const registerNotificationsMutation = `
mutation RegisterNotifications($input: RegisterNotificationsInput) {
  registerNotifications(input: $input)
}
`;

export const keywordsQuery = `
query Keywords($networkId: Int!) {
  keywords(networkId: $networkId) {
    keywords
    network {
      id
      symbol
      explorer
    }
  }
}
`;

export const addKeywordMutation = `
mutation AddKeyword($input: KeywordsInput) {
  addKeyword(input: $input)
}
`;

export const removeKeywordMutation = `
mutation RemoveKeyword($input: KeywordsInput) {
  removeKeyword(input: $input)
}
`;

export const notificationsQuery = `
query Notifications($page: PageArgs, $filter: NotificationFilter) {
  notifications(pageArgs: $page, filter: $filter) {
    edges {
      cursor
      node {
        id
        createdAt
        network {
          symbol
          explorer
        }
        type
        token {
          logoUrl
          createdAt
          address
          name
          symbol
          decimals
          supply
          deployer
          deployerBalance
          deploymentChecksum
          interfaceChecksum
          creationTx
          buyTax
          sellTax
          verifiedAt
          confirmedAt
          seenAt
          socialsBy
          telegram
          twitter
          contractState
          socialsAt
          scamAt
          description
          website
          email
          blog
          reddit
          slack
          github
          wechat
          linkedin
          discord
          whitepaper
          bitcointalk
          network {
            id
            explorer
            symbol
          }
        }
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      totalCount
      startCursor
      endCursor
    }
  }
}
`;

export const notificationSubscription = `
subscription NotificationSub($filter: NotificationFilter!) {
  notifications(filter: $filter) {
    id
    createdAt
    network {
      symbol
      explorer
    }
    type
    status
    token {
      logoUrl
      createdAt
      address
      name
      symbol
      decimals
      supply
      deployer
      deployerBalance
      deploymentChecksum
      interfaceChecksum
      creationTx
      verifiedAt
      confirmedAt
      seenAt 
      buyTax
      sellTax
      scamAt
      socialsBy
      telegram
      twitter
      contractState
      socialsAt
      description
      website
      email
      blog
      reddit
      slack
      github
      wechat
      linkedin
      discord
      whitepaper
      bitcointalk
      network {
        id
        explorer
        symbol
      }
    }
  }
}`;

export const addTrackedAddressMutation = `
mutation AddTrackedAddress($input: TrackedAddressInput) {
  addTrackedAddresses(input: $input)
}
`;

export const removeTrackedAddressMutation = `
mutation RemoveTrackedAddress($input: TrackedAddressInput) {
  removeTrackedAddresses(input: $input)
}
`;

export const txNotificationsQuery = `
query Notifications($page: PageArgs, $filter: NotificationFilter) {
  notifications(pageArgs: $page, filter: $filter) {
    edges {
      cursor
      node {
        id
        createdAt
        status
        network {
          symbol
          explorer
        }
        type
        transaction {
          hash
          createdAt
          network {
            symbol
            explorer
          }
          type
          status
          from
          to
          method
          data
          decodedData
          decodedLogs
          internalLogs
          value
          marketCap
          addresses
          tokens {
            logoUrl
            createdAt
            address
            name
            symbol
            decimals
            supply
            deployer
            deployerBalance
            deploymentChecksum
            interfaceChecksum
            creationTx
            buyTax
            sellTax
            verifiedAt
            confirmedAt
            seenAt
            socialsBy
            telegram
            twitter
            contractState
            socialsAt
            scamAt
            description
            website
            email
            blog
            reddit
            slack
            github
            wechat
            linkedin
            discord
            whitepaper
            bitcointalk
            network {
              id
              explorer
              symbol
            }
          }
        }
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      totalCount
      startCursor
      endCursor
    }
  }
}
`;

export const txNotificationSubscription = `
subscription NotificationSub($filter: NotificationFilter!) {
  notifications(filter: $filter) {
    id
    createdAt
    status
    network {
      symbol
      explorer
    }
    type
    transaction {
      hash
      createdAt
      network {
        symbol
        explorer
      }
      type
      status
      from
      to
      method
      data
      decodedData
      decodedLogs
      internalLogs
      value
      marketCap
      addresses
      tokens {
        logoUrl
        createdAt
        address
        name
        symbol
        decimals
        supply
        deployer
        deployerBalance
        deploymentChecksum
        interfaceChecksum
        creationTx
        buyTax
        sellTax
        verifiedAt
        confirmedAt
        seenAt
        socialsBy
        telegram
        twitter
        contractState
        socialsAt
        scamAt
        description
        website
        email
        blog
        reddit
        slack
        github
        wechat
        linkedin
        discord
        whitepaper
        bitcointalk
        network {
          id
          explorer
          symbol
        }
      }
    }
  }
}`;

export const trackedAddressesQuery = `
query TrackedAddresses($pageArgs: PageArgs, $filter: TrackedAddressFilter) {
  trackedAddresses(pageArgs: $pageArgs, filter: $filter) {
    edges {
      cursor
      node {
        address
        nameTag {
          name
          address
          editable
          type
        }
        network {
          id
          explorer
        }
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
      totalCount
    }
  }
}`;

export const updateTrackedAddressMutation = `
mutation UpdateTrackedAddresses($input: TrackedAddressInput) {
  updateTrackedAddresses(input: $input)
}
`;

export const updateNotificationSettingsMutation = `
mutation UpdateNotificationSettings($input: NotificationSettingsInput!) {
  updateNotificationSettings(input: $input) {
    id
    all
    transactions
    keywords
    confirmedTokens
    pendingTokens
    verifiedTokens
    tokenSocials
    approvals
    stdTokens
    devTokens
    liqTokens
  }
}
`;

export const notificationSettingsQuery = `
query NotificationSettings($networkId: Int!) {
  notificationSettings(networkId: $networkId) {
    id
    all
    transactions
    keywords
    confirmedTokens
    pendingTokens
    verifiedTokens
    tokenSocials
    approvals
    stdTokens
    devTokens
    liqTokens
	}
}
`;

export const logoutMutation = `
mutation LogoutSession($refreshToken: String!) {
  logout(refreshToken: $refreshToken)
}
`;

export const logoutAllMutation = `
mutation LogoutAllSessions {
  logoutAllSessions
}
`;

export const updateTokenMutation = `
mutation UpdateToken($input: UpdateTokenInput!) {
  updateToken(input: $input) {
    createdAt
    address
    name
    symbol
    decimals
    supply
    deployer
    deployerBalance
    deploymentChecksum
    interfaceChecksum
    creationTx
    verifiedAt
    confirmedAt
    seenAt
    socialsBy
    scamAt
    buyTax
    sellTax
    telegram
    twitter
    contractState
    socialsAt
    description
    website
    email
    blog
    reddit
    slack
    github
    wechat
    linkedin
    discord
    whitepaper
    bitcointalk
    network {
      id
      explorer
      symbol
    }
  }
}
`;

export const candlesQuery = gql`
  query GetCandles($input: CandlesInput!) {
    candles(input: $input) {
      open
      high
      low
      close
      volumeBase
      timestamp
    }
  }
`;

export const tradesSubscription = gql`
  subscription OnTrade($pair: String!) {
    trades(pair: $pair) {
      pair {
        baseToken {
          logoUrl
          symbol
        }
        token {
          logoUrl
          symbol
        }
      }
      price
      amountToken
      amountBase
      amountNative
      amountUSD
      timestamp
      maker
      transactionHash
      blockNumber
      isNative
      type
    }
  }
`;

export const unreadNotificationCountQuery = `
  query UnreadNotificationCount($filter: NotificationFilter) {
    unreadNotificationCount(filter: $filter)
  }
`;

export const markNotificationsAsReadMutation = `
  mutation MarkNotificationsAsRead($beforeAtId: Int!, $filter: NotificationFilter!) {
    markNotificationsAsRead(beforeAtId: $beforeAtId, filter: $filter)
  }
`;

export const addSystemListValueMutation = `
  mutation AddSystemListValue($type: SystemListType!, $value: String!) {
    addSystemListValue(type: $type, value: $value)
  }
`;

export const removeSystemListValueMutation = `
  mutation RemoveSystemListValue($type: SystemListType!, $value: String!) {
    removeSystemListValue(type: $type, value: $value)
  }
`;

export const systemListQuery = `
  query SystemList($type: SystemListType!) {
    systemList(type: $type)
  }
`;
